module.exports = __webpack_public_path__ + "static/media/16.4a7156ca.jpg";